import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Col, Input, Row } from 'reactstrap';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import DataTable from 'src/Components/DataTable';
import { UserStore } from 'src/Stores/User/UserStore';
// import EInput from 'src/Components/EInput';
// import TenantStore from 'src/Stores/Tenant/TenantStore';
// import { UserStore } from 'src/Stores/User/UserStore';
import { IReleaseNotes } from '../../../Interfaces/UserInterface';
// import WorkflowHeader from '../../WorkflowHeader';
import './ReleaseNotes.scss';

@inject('stores')
@observer
class ReleaseNotes extends React.Component{
    public props: any;
    public UserStore: UserStore;
    // private TenantStore: TenantStore;

    private releaseNote: IReleaseNotes = new IReleaseNotes();
    private releaseNotes: IReleaseNotes[] = [];
    public releaseNotesDisposer: any;


    public state = {

      releaseNote: this.releaseNote,
      releaseNotes:  this.releaseNotes,
      selectedFile: [] as any
    };


    constructor(props: any) {
        super(props);
        // this.TenantStore = this.props.stores.TenantStore;
        this.UserStore = this.props.stores.UserStore;
    }

    public componentDidMount() {
        this.createDisposers();

          this.UserStore.getAllReleaseNotes();
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.releaseNotesDisposer = intercept(this.UserStore, 'releaseNotes', (change: any) => {
            this.setState({
                releaseNotes: change.newValue
            });
              this.formatReleaseNotes();

            return change;
        });
    }

    public clearDisposers() {
        this.releaseNotesDisposer();
    }

    public onFileChange = (event: any) => {
        this.setState({
            selectedFile: event.target.files
        });
    }

    public onFileUpload = () => {
        if (!this.state.selectedFile) {
            return;
        }

        const formData = new FormData();
        for (const file of this.state.selectedFile) {
            formData.append(`File`, file);
        }
        this.UserStore.postReleaseNote(formData)
        .then((data: any) => {
            if(data) {
                this.UserStore.getAllReleaseNotes();
                this.setState({
                    selectedFile: []
                });
                console.log(this.state.selectedFile);
                const fileInput = document.getElementById("file") as any;
                if (fileInput) {
                    fileInput.value = '';
                }
            }
        });
    }

    private handleDownload = (note: any) => () => {
        return this.UserStore.getReleaseNote(note.id, note.name);
    }

    private handleOpenNewWindow = (note: any) => () => {
        return this.UserStore.openReleaseNoteInNewTab(note.id);
    }

    public renderDownload = (note: any) => () => {
        if (note.name.includes('.pdf')) {
            return <React.Fragment>
                <Button
                    color="primary"
                    onClick={this.handleDownload(note)}
                >Download</Button>
                <Button
                    color="primary"
                    onClick={this.handleOpenNewWindow(note)}
                >Open in New Tab</Button>
            </React.Fragment>;
        }
        return <Button
            color="primary"
            onClick={this.handleDownload(note)}
        >Download</Button>;
    }

    private handleDeleteNote = (index: number) => {
        const noteToDelete = this.state.releaseNotes[index];
        this.UserStore.deleteReleaseNote(noteToDelete.id)
            .then((data: any) => {
                if (data) {
                    // this.MessageStore.addMessage('File Deleted', 'success');
                    this.UserStore.getAllReleaseNotes();
                }
            });
    }

    private formatReleaseNotes = () => {
        const notes = this.state.releaseNotes;
        const headers = [
            'Version',
            'Upload Date',
            'Download'
        ];
    
        const rows = notes.map((f, index) => {
            return [
                {
                    content: f.name
                },
                {
                    content: f.createDate
                },
                {
                    content: this.renderDownload(f),
                    type: 'render',
                }
            ];
        });
        return { headers, rows };
    }

    

    public render() {
        return(
       
            <div className='ReleaseNotes'>
                     <Row className='header'>
                    <Col md="6">
                        <h1>Release Notes</h1>
                    </Col>
                    </Row>
                <div className='ReleaseNotes-Content'>
                <Row>
                { this.UserStore.user.id === "8e205b5b-b9bc-4382-a9a7-0a0f198539c2" &&
                    <Col>
                        <FormGroup>
                            <Label>Upload File</Label>
                            <Input
                                type="file"
                                name="file"
                                id="file"
                                multiple={true}
                                onChange={this.onFileChange}
                            />
                        </FormGroup>
                    </Col>
                        }
                    { this.UserStore.user.id === "8e205b5b-b9bc-4382-a9a7-0a0f198539c2"  &&
                    <Col className='upload'>
                        <Button
                            color="primary"
                            onClick={this.onFileUpload}
                        >
                            Upload File
                        </Button>
                    </Col>
                        }
                </Row>
                </div>
                <Row>
                    <Col>
                        <DataTable
                            list={this.formatReleaseNotes()}
                            onDelete={this.handleDeleteNote}
                        />
                    </Col>
                </Row>
            
                {/* <footer className="ReleaseNotes-footer">
                    <p className="float-left">© MudMetrix, 2022</p>
                   <p className="float-right">Last Updated: TBD | Version 2.1.5</p>
                </footer> */}
            </div>
        );
    }
}





export default withRouter(ReleaseNotes);


// WEBPACK FOOTER //
// ./src/Components/Main/ReleaseNotes/ReleaseNotes.tsx